export const invoiceDisplayFields = {
  status: {
    order: 90,
    sortable: true,
    displayType: 'badge',
    valueToLabel: [
      { value: 'draft', label: 'global.status.draft' },
      { value: 'paid', label: 'global.status.paid' },
      { value: 'to_pay', label: 'global.status.to_pay' },
      { value: 'cancelled', label: 'global.status.cancelled' },
      { value: 'timer_expired', label: 'global.status.timer_expired' },
    ],
    valueToVariant: [
      { value: 'paid', variant: 'success' },
      { value: 'to_pay', variant: 'warning' },
      { value: 'cancelled', variant: 'danger' },
      { value: 'timer_expired', variant: 'danger' },
    ],
    toTranslate: true,
  },
};

export const paymentDisplayFields = {
  payment_method_type: {
    displayType: 'badge',
    toTranslate: true,
    valueToLabel: [
      { value: 'cash', label: 'accounting.payments.payment_method_type.cash.label' },
      {
        value: 'money_transfer',
        label: 'accounting.payments.payment_method_type.money_transfer.label',
      },
      { value: 'debit_card', label: 'accounting.payments.payment_method_type.debit_card.label' },
      { value: 'credit_card', label: 'accounting.payments.payment_method_type.credit_card.label' },
      { value: 'cheque', label: 'accounting.payments.payment_method_type.cheque.label' },
      {
        value: 'sport_cheque',
        label: 'accounting.payments.payment_method_type.sport_cheque.label',
      },
      { value: 'stripe_card', label: 'accounting.payments.payment_method_type.stripe.label' },
      { value: 'paypal', label: 'accounting.payments.payment_method_type.paypal.label' },
      { value: 'cashdro', label: 'accounting.payments.payment_method_type.cashdro.label' },
      { value: 'clearance', label: 'accounting.payments.payment_method_type.clearance.label' },
    ],
  },
};
